import { formatNumber } from '@ayub/shared'
import { Banknote, CircleCheck, ReceiptText } from '@/lib/icons'
import type { IconType } from '@/lib/icons'
import { cn } from '@/lib/utils'

export type PayoutTab = 'requests' | 'ready' | 'history'

interface PayoutTabsProps {
  value: PayoutTab
  onChange: (tab: PayoutTab) => void
  requestsCount: number | undefined
  readyCount: number | undefined
  isLoading: boolean
}

/**
 * Uchta tab — `docs/03-app-flow.md` Sahifa 4: "[ 💸 So'rovlar (3) ] [ ✅ To'lovga tayyor (18) ]
 * [ 📜 Tarix ]". Sonlar `PayoutSummary`dan (`usePayoutSummary()`), joriy tabdan MUSTAQIL —
 * `BloggerStageChips` naqshiga mos.
 */
export function PayoutTabs({
  value,
  onChange,
  requestsCount,
  readyCount,
  isLoading,
}: PayoutTabsProps) {
  return (
    <div
      role="tablist"
      aria-label="To'lovlar bo'limlari"
      className="flex gap-2 overflow-x-auto pb-1"
    >
      <TabButton
        icon={Banknote}
        label="So'rovlar"
        count={requestsCount}
        isLoading={isLoading}
        active={value === 'requests'}
        onClick={() => onChange('requests')}
      />
      <TabButton
        icon={CircleCheck}
        label="To'lovga tayyor"
        count={readyCount}
        isLoading={isLoading}
        active={value === 'ready'}
        onClick={() => onChange('ready')}
      />
      <TabButton
        icon={ReceiptText}
        label="Tarix"
        count={undefined}
        isLoading={false}
        active={value === 'history'}
        onClick={() => onChange('history')}
      />
    </div>
  )
}

function TabButton({
  icon: Icon,
  label,
  count,
  isLoading,
  active,
  onClick,
}: {
  icon: IconType
  label: string
  count: number | undefined
  isLoading: boolean
  active: boolean
  onClick: () => void
}) {
  return (
    <button
      type="button"
      role="tab"
      aria-selected={active}
      onClick={onClick}
      className={cn(
        'inline-flex h-11 shrink-0 items-center gap-1.5 rounded-button border px-3 text-sm font-medium transition-colors duration-150 ease-out',
        active
          ? 'border-brand bg-brand-subtle text-brand'
          : 'border-app-border text-app-hint hover:text-app-text',
      )}
    >
      <Icon size={16} aria-hidden="true" className="shrink-0" />
      {label}
      {count !== undefined && (
        <span className="tabular text-xs opacity-80">
          {isLoading ? '…' : `(${formatNumber(count)})`}
        </span>
      )}
    </button>
  )
}
